<template>
  <div class="user-register">

    <el-form :model="form" status-icon :rules="rules" ref="form" label-width="100px" class="user-register-form">
      <h1>账户系统</h1>
      <el-form-item label="账户名" prop="user">
        <el-input type="text" v-model="form.user" auto-complete="off" placeholder='用于登录账户系统'></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="pass">
        <el-input v-model="form.pass" type="password" placeholder='请谨记密码'></el-input>
      </el-form-item>
      <el-form-item label="联系人姓名" prop="name">
        <el-input v-model="form.name" type="email" placeholder='填入联系人姓名'></el-input>
      </el-form-item>
      <el-form-item label="工作邮箱" prop="email">
        <el-input v-model="form.email" type="email" placeholder='工作邮箱'></el-input>
      </el-form-item>
      <el-form-item label="联系手机号" prop="phone">
        <el-input v-model="form.phone" type="text" placeholder='联系手机号'></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="register">注册账户</el-button>
      </el-form-item>

      <el-button type="text">
        <span @click='backlogin'>
          返回登录页
        </span>
      </el-button>


    </el-form>
  </div>
</template>
<script>
  export default {
    name: 'register',
    data() {
      return {
        msg: 'hahhh',
        form: {
          user: null,
          pass: null,
          name: null,
          email: null,
          phone: null
        },
        rules: {
          user: [{
            required: true,
            message: '请输入账户名！',
            trigger: 'blur'
          }],
          pass: [{
            required: true,
            message: '请输入账户密码！',
            trigger: 'blur'
          }],
          name: [{
            required: true,
            message: '请输入你的姓名！',
            trigger: 'blur'
          }],
          email: [{
            required: true,
            message: '请输入你的工作邮箱！',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '请输入你的手机号！',
            trigger: 'blur'
          }]
        }
      }
    },
    methods: {
      register() {
        const {
          user,
          pass,
          phone,
          name,
          email
        } = this.form;
        if (!user || !pass || !phone || !email || !name) {
          this.$message({
            message: '警告!数据不完整,请仔细填写表单',
            type: 'warning',
            center: true
          })
        } else {

          this.$http.user_register({
            user,
            pass,
            phone,
            name,
            email
          }).then(res => {
            if (res.data.statusCode === 200) {
              this.$router.push("/login")
              this.$notify({
                title: `(｀・ω・´)注册成功`,
                message: `${res.data.message}`,
                duration: 5000,
                type: 'success'
              })
            } else {
              this.$notify({
                title: `(；"⌒")注册失败`,
                message: `${res.data.message}`,
                duration: 5000,
                type: 'error'
              })
            }
          })
        }
      },
      backlogin() {
        this.$router.push('/login')
      }
    }
  }

</script>
<style scoped>
  .user-register-form {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 100px auto;
    width: 600px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
  }

  .user-register-form h1 {
    margin: 0px auto 35px auto;
    text-align: center;
    color: #505458;
    font-size: 18px;
  }

  .user-register {
    position: absolute;
    background: url(/static/xxx.JPG) no-repeat;
    background-size: 100% 100%;
    height: 100%;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/backend/register.vue